import { Clock } from "lucide-react";
import { Button } from "../ui/button";
import { OUTLINE_BRAND_BTN_CLASS } from "./constants";
import { KEEP_MY_SUBSCRIPTION, bannerTitle } from "./cancel-after-delivery-copy";

/** Shown while a "cancel after next delivery" is scheduled; Keep undoes it. */
export function ScheduledCancelBanner({
  endDate,
  onKeep,
  keepPending,
}: {
  endDate: string | null;
  onKeep: () => void;
  keepPending: boolean;
}) {
  return (
    <div className="tw:rounded-xl tw:bg-[#FDEDEE] tw:px-4 tw:py-3 tw:flex tw:flex-col tw:gap-2.5 tw:text-[#523D33]">
      <div className="tw:flex tw:items-start tw:gap-2">
        <Clock className="tw:w-4 tw:h-4 tw:shrink-0 tw:mt-0.5" />
        <span className="tw:text-sm tw:font-semibold">
          {endDate ? bannerTitle(endDate) : "Ends after your next delivery"}
        </span>
      </div>
      <Button
        type="button"
        variant="outline"
        disabled={keepPending}
        onClick={onKeep}
        className={OUTLINE_BRAND_BTN_CLASS}
      >
        {KEEP_MY_SUBSCRIPTION}
      </Button>
    </div>
  );
}
